import { render, staticRenderFns } from "./EpBdFactoryAreaModal.vue?vue&type=template&id=b2aa6afe&"
import script from "./EpBdFactoryAreaModal.vue?vue&type=script&lang=js&"
export * from "./EpBdFactoryAreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2aa6afe')) {
      api.createRecord('b2aa6afe', component.options)
    } else {
      api.reload('b2aa6afe', component.options)
    }
    module.hot.accept("./EpBdFactoryAreaModal.vue?vue&type=template&id=b2aa6afe&", function () {
      api.rerender('b2aa6afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/EpBdFactoryAreaModal.vue"
export default component.exports